import { SettingsSection } from '@common/components/SettingsSection';
import { SettingsPageContent } from '@common/components/SettingsTableOfContents';

import { BusinessAddressesForm } from './BusinessAddressesForm';
import { BusinessContactForm } from './BusinessContactForm';
import { BusinessHoursForm } from './BusinessHoursForm';
import { BusinessIdentityForm } from './BusinessIdentityForm';

const TOC_ITEMS = [
	{ id: 'business-identity', title: 'Business identity' },
	{ id: 'addresses', title: 'Addresses' },
	{ id: 'primary-contact', title: 'Primary contact' },
	{ id: 'business-hours', title: 'Business hours' },
];

/**
 * BusinessDetailsForms composes all business detail forms together
 * using the two-column SettingsSection layout for each form.
 */
export function BusinessDetailsForms() {
	return (
		<SettingsPageContent tocItems={TOC_ITEMS} stickyTop={32}>
			<SettingsSection
				title='Business identity'
				description='Your dealership name and primary contact information.'>
				<BusinessIdentityForm />
			</SettingsSection>
			<SettingsSection
				title='Addresses'
				description='Legal and physical addresses for your business.'>
				<BusinessAddressesForm />
			</SettingsSection>
			<SettingsSection
				title='Primary contact'
				description='The main point of contact for your dealership.'>
				<BusinessContactForm />
			</SettingsSection>
			<SettingsSection
				title='Business hours'
				description='Set the hours your customer support line is available.'
				hideDivider>
				<BusinessHoursForm />
			</SettingsSection>
		</SettingsPageContent>
	);
}

export default BusinessDetailsForms;
